YP.EventManager = function() {
    var btnAlreadyOrdered       = $("#lost-order #already-ordered");
    var formAlreadyOrdered      = $("#form-already-ordered");
    var btnSubmitAlreadyOrdered = $("#submit-already-ordered", formAlreadyOrdered);
    var messageAjaxError        = $("#field_email_address .help-block", formAlreadyOrdered);

    return {
        init: function() {
            YP.EventManager().initAlreadyOrdered();
            
            $('.object-admin-design-btn').click(function(e){
                $('.show_design_panel').toggle();
                e.preventDefault();
            });
        },
        initAlreadyOrdered : function(){

            if(btnAlreadyOrdered.length > 0 && btnSubmitAlreadyOrdered.length > 0){

                var _isWidget = formAlreadyOrdered.data("widget");


                btnAlreadyOrdered.on("click", function(e){
                    e.preventDefault();
                    formAlreadyOrdered.slideToggle();
                })

                if(_isWidget){


                    formAlreadyOrdered.keypress('keyup keypress', function(e) {
                        var code = e.keyCode || e.which;
                        if (code == 13) {
                            e.preventDefault();
                            return false;
                        }
                    });
                }

                btnSubmitAlreadyOrdered.on("click", function(e){
                    e.preventDefault();

                    var _text     = btnSubmitAlreadyOrdered.html();


                    btnSubmitAlreadyOrdered.attr('disabled', 'disabled');
                    btnSubmitAlreadyOrdered.html('<i class="fa fa-spinner fa-spin"></i>');

                    $.post(
                        formAlreadyOrdered.attr("action"),
                        formAlreadyOrdered.serialize(),
                        function success(data){

                            if(data.status == "valid"){

                                $("#lost-order").after("<p id='result-lost-order'>" + data.messages + "</p>");

                                formAlreadyOrdered.slideToggle();
                                setTimeout(function(){
                                    $("#result-lost-order").remove();
                                }, 8000);
                            }
                            else if(typeof data.messages.email_address != "undefined"){

                                messageAjaxError.text(data.messages.email_address);
                                setTimeout(function(){
                                    messageAjaxError.text("");
                                }, 5000);
                            }

                        },
                        'json'
                    )
                    .fail(function(data){

                        messageAjaxError.text("Une erreur s'est produite");
                        setTimeout(function(){
                            messageAjaxError.text("");
                        }, 5000);

                    })
                    .always(function(){
                        btnSubmitAlreadyOrdered.removeAttr('disabled');
                        btnSubmitAlreadyOrdered.html(_text);

                    });
                })
            }
        }
    }

};

window.addEventListener("load", function(){
    YP.EventManager().init();
});
